import { useState } from 'react';
import { useAsyncEffect } from 'rooks';
import { FakeLink } from '@/core/FakeLink';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { goToWorksheet } from '@/impactReports/impactReport.utilities';
import { sqWorkbooksApi } from '@seeqdev/api/endpoint/WorkbooksApi';

interface SelectedWorksheetDisplayAndLinkProps {
  worksheetId: string;
  workbookId: string;
  extraClassNames?: string;
}
export const SelectedWorksheetDisplayAndLink = ({
  workbookId,
  worksheetId,
  extraClassNames,
}: SelectedWorksheetDisplayAndLinkProps) => {
  const [selectedWorksheetDisplayName, setSelectedWorksheetDisplayName] = useState('');
  const preferNewTab = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.preferNewTab);

  useAsyncEffect(async () => {
    if (!workbookId || !worksheetId) return;
    const workbookResponse = await sqWorkbooksApi.getWorkbook({ id: workbookId });
    const worksheetResponse = await sqWorkbooksApi.getWorksheet({ workbookId, worksheetId });
    setSelectedWorksheetDisplayName(`${workbookResponse.data?.name} - ${worksheetResponse.data?.name}`);
  }, [worksheetId, workbookId]);

  return (
    <FakeLink
      onClick={() => goToWorksheet(worksheetId, preferNewTab)}
      extraClassNames={extraClassNames ? `truncateWSLink ${extraClassNames}` : 'truncateWSLink'}>
      {selectedWorksheetDisplayName}
    </FakeLink>
  );
};
